const locales = {
	bg_BG: {
		datefns: ['bg'],
		filepond: [],
		parsleyjs: ['bg'],
		select2: ['bg'],
		tinymce: ['bg_BG'],
		uppy: ['bg_BG'],
	},
	bs_BA: {
		datefns: ['bs'],
		filepond: [],
		parsleyjs: ['bs'], // not available in parsley but webpack will simply fail silently - it is the same as setting an empty array
		select2: ['bs'],
		tinymce: [], // no en_US available, so it must be set as null
		uppy: ['en_US'],
	},
	cs_CZ: {
		datefns: ['cs'],
		filepond: ['cs-cz'],
		parsleyjs: ['cs', 'cs.extra'], // not available in parsley but webpack will simply fail silently - it is the same as setting an empty array
		select2: ['cs'],
		tinymce: ['cs'],
		uppy: ['cs_CZ'],
	},
	de_DE: {
		datefns: ['de'],
		filepond: ['de-de'],
		parsleyjs: ['de', 'de.extra'],
		select2: ['de'],
		tinymce: ['de'],
		uppy: ['de_DE'],
	},
	el_GR: {
		datefns: ['el'],
		filepond: [],
		parsleyjs: ['el', 'el.extra'],
		select2: ['el'],
		tinymce: ['el'],
		uppy: ['el_GR'],
	},
	en_AU: {
		datefns: ['en-AU'],
		filepond: [],
		parsleyjs: ['en', 'en.extra'],
		select2: ['en'],
		tinymce: [], // no en_US available, so it must be set as null
		uppy: ['en_US'],
	},
	en_IN: {
		datefns: ['en-IN'],
		filepond: [],
		parsleyjs: ['en', 'en.extra'],
		select2: ['en'],
		tinymce: [], // no en_US available, so it must be set as null
		uppy: ['en_US'],
	},
	en_GB: {
		datefns: ['en-GB'],
		filepond: [],
		parsleyjs: ['en', 'en.extra'],
		select2: ['en'],
		tinymce: [],
		uppy: ['en_US'],
	},
	en_US: {
		datefns: ['en-US'],
		filepond: [],
		parsleyjs: ['en', 'en.extra'],
		select2: ['en'],
		tinymce: [], // no en_US available, so it must be set as null
		uppy: ['en_US'],
	},
	es_ES: {
		datefns: ['es'],
		filepond: ['es-es'],
		parsleyjs: ['es'],
		select2: ['es'],
		tinymce: ['es'],
		uppy: ['es_ES'],
	},
	es_MX: {
		datefns: ['es'],
		filepond: ['es-es'],
		parsleyjs: ['es'],
		select2: ['es'],
		tinymce: ['es_MX'],
		uppy: ['es_ES'],
	},
	fr_FR: {
		datefns: ['fr'],
		filepond: ['fr-fr'],
		parsleyjs: ['fr', 'fr.extra'],
		select2: ['fr'],
		tinymce: ['fr_FR'],
		uppy: ['fr_FR'],
	},
	hr_HR: {
		datefns: ['hr'],
		filepond: ['hr-hr'],
		parsleyjs: ['hr', 'hr.extra'],
		select2: ['hr'],
		tinymce: ['hr'],
		uppy: ['hr_HR'],
	},
	hu_HU: {
		datefns: ['hu'],
		filepond: ['hu-hu'],
		parsleyjs: ['hu', 'hu.extra'],
		select2: ['hu'],
		tinymce: ['hu_HU'],
		uppy: ['hu_HU'],
	},
	it_IT: {
		datefns: ['it'],
		filepond: ['it-it'],
		parsleyjs: ['it', 'it.extra'],
		select2: ['it'],
		tinymce: ['it'],
		uppy: ['it_IT'],
	},
	mk_MK: {
		datefns: ['mk'],
		filepond: [],
		parsleyjs: ['mk'],
		select2: ['mk'],
		tinymce: [], // no en_US available, so it must be set as null
		uppy: ['en_US'],
	},
	nl_NL: {
		datefns: ['nl'],
		filepond: ['nl-nl'],
		parsleyjs: ['nl', 'nl.extra'],
		select2: ['nl'],
		tinymce: ['nl'],
		uppy: ['nl_NL'],
	},
	pl_PL: {
		datefns: ['pl'],
		filepond: ['pl-pl'],
		parsleyjs: ['pl'],
		select2: ['pl'],
		tinymce: ['pl'],
		uppy: ['pl_PL'],
	},
	pt_BR: {
		datefns: ['pt-BR'],
		filepond: ['pt-br'],
		parsleyjs: ['pt-br'],
		select2: ['pt-BR'],
		tinymce: ['pt_BR'],
		uppy: ['pt_BR'],
	},
	pt_PT: {
		datefns: ['pt'],
		filepond: [],
		parsleyjs: ['pt-pt'],
		select2: ['pt'],
		tinymce: ['pt_BR'], // no pt_PT available
		uppy: ['pt_PT'],
	},
	ro_RO: {
		datefns: ['ro'],
		filepond: [],
		parsleyjs: ['ro', 'ro.extra'],
		select2: ['ro'],
		tinymce: ['ro'],
		uppy: ['ro_RO'],
	},
	ru_RU: {
		datefns: ['ru'],
		filepond: ['ru-ru'],
		parsleyjs: ['ru', 'ru.extra'],
		select2: ['ru'],
		tinymce: ['ru'],
		uppy: ['ru_RU'],
	},
	sl_SI: {
		datefns: ['sl'],
		filepond: [],
		parsleyjs: ['sl', 'sl.extra'],
		select2: ['sl'],
		tinymce: [], // no en_US available, so it must be set as null
		uppy: ['en_US'],
	},
	sk_SK: {
		datefns: ['sk'],
		filepond: ['sk-sk'],
		parsleyjs: ['sk'],
		select2: ['sk'],
		tinymce: ['sk'],
		uppy: ['sk_SK'],
	},
	sv_SE: {
		datefns: ['sv'],
		filepond: ['sv_se'],
		parsleyjs: ['sv', 'sv.extra'],
		select2: ['sv'],
		tinymce: ['sv_SE'],
		uppy: ['sv_SE'],
	},
	sr_RS: {
		datefns: ['sr'],
		filepond: [],
		parsleyjs: ['sr', 'sr.extra'],
		select2: ['sr'],
		tinymce: ['sr'],
		uppy: ['sr_RS_Latin'], // also sr_RS_Cyrillic available
	},
};

/**
 * @param {string} str
 */ // eslint-disable-next-line prefer-named-capture-group
const reQuote = str => str.replace(/([$()*+./?[\\\]^{|}])/, '\\$1');

/**
 * @param {string} entity
 */
const getLocalesFor = (entity, doReQuote = false) => {

	const buff = [];

	for (const [, list] of Object.entries(locales)) {
		/** @type {string[]} */
		const entityLocales = list[entity];
		// No locales
		if (!entityLocales || entityLocales.length === 0) {
			continue;
		}
		buff.push(...(
			doReQuote
				? entityLocales.map((/** @type {string} */ locale) => reQuote(locale))
				: entityLocales
		));
	}

	return buff;
};

/**
 * @param {string} locale
 * @param {string} entity
 */
const getCurrentLocalesFor = (locale, entity) => (locales[locale]?.[entity] || []);

module.exports = {
	locales,
	getLocalesFor,
	getCurrentLocalesFor,
};
